import { action, computed, makeAutoObservable } from 'mobx';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

export class MultiOptionSelectState {
    public checked: string[] = [];
    public expanded: string[] = [];
    public isVisited: boolean = false;
    public showAllBadges = false;
    public isExpanded = false;
    public constructor(public readonly formInputState: FormInputState<string, string>) {
        makeAutoObservable(this);

        for (const el of this.parseInput(formInputState.value)) {
            this.checked.push(el);
        }
    }

    private parseInput(s: string): string[] {
        try {
            const inputArray: string[] = JSON.parse(s);
            if (Array.isArray(inputArray)) {
                return inputArray;
            }
            return [];
        } catch (e) {
            return [];
        }
    }

    @computed public get visibleChecked(): { display: string[]; remaining: number } {
        const maxVisible = 3;

        if (this.showAllBadges) {
            return { display: this.checked, remaining: 0 };
        }

        const visibleChecked = this.checked.slice(0, maxVisible);
        const remaining = Math.max(0, this.checked.length - maxVisible);
        return { display: visibleChecked, remaining };
    }

    @computed public get visibleCheckedWithLabels(): { value: string; label: string }[] {
        const maxVisible = 3;
        const checkedToDisplay = this.showAllBadges ? this.checked : this.checked.slice(0, maxVisible);

        return checkedToDisplay.map((value) => ({
            value,
            label: value,
        }));
    }

    @action public toggleExpanded(): void {
        this.setExpanded(!this.isExpanded);
    }

    @action public setExpanded(expanded: boolean): void {
        if (!expanded && this.isVisited) {
            this.formInputState.setAsVisited();
        }
        if (expanded) {
            this.isVisited = true;
        }
        this.isExpanded = expanded;
    }

    private setChecked(checked: string[]): void {
        this.checked = checked;
        this.formInputState.setValueOnChange(JSON.stringify(checked));
    }

    public toggleShowAllBadges(): void {
        this.showAllBadges = !this.showAllBadges;
    }
    public handleExpand(expanded: string[]): void {
        this.expanded = expanded;
    }
    public handleCheck(checked: string[]): void {
        this.setChecked(checked);
    }
    public clearChecked(): void {
        this.checked = [];
        this.formInputState.setValue('');
        this.showAllBadges = false;
    }
    public handleRemoveChecked(value: string): void {
        this.setChecked(this.checked.filter((item) => item !== value));
    }
}
